export default "__VITE_ASSET__CYt9gGKw__"